<script setup lang="ts">
import type { City } from '~~/interfaces/city'
import useCityStore from '~~/app/store/city'

const cityStore = useCityStore()

const props = defineProps({
    closeCity: {
        type: Object as PropType<City>,
        default: () => ({})
    }
})

const closeCityName = computed<string>(
    () => props.closeCity?.name || cityStore.name
)

const closeCitySlug = computed<string>(
    () => props.closeCity?.slug || cityStore.slug
)

const closeCityCountryCode = computed<string>(
    () => props.closeCity?.countryCode || cityStore.countryCode
)
</script>

<template>
    <NuxtLink
        :to="
            getChargemapUrl(`/cities/${closeCitySlug}-${closeCityCountryCode}`)
        "
        :title="closeCityName"
    >
        {{ closeCityName }}
    </NuxtLink>
</template>

<style scoped lang="scss">
a {
    @apply text-sky-500 hover:text-sky-400;
}
</style>
